export default {
  home: {
    title: '旗下游戏'
  },
  foot: {
    title: '点点互动',
    p1: '点点互动是专注游戏研发和发行的全球化娱乐公司，游戏品类覆盖休闲和中重度游戏，目标是打造高质量的跨平台游戏，致力于给玩家提供极致的娱乐体验。',
    p2: '若您对游戏有任何疑问，请在游戏内点击客服按钮联系专属游戏客服，感谢您一直以来的支持！',
    copyright: '@版权所有 2023 Century Games'
  },
  accept: {
    title: '为了让您体验更优质的服务，本网站将使用cookies，您可以通过阅读我们的<a href="https://www.centurygames.com/zh/privacy-policy/" style="color: #58a8a5;">《隐私政策》</a>来了解有关信息采集的详细内容。如果你选择继续浏览，则代表您允许我们存储及获取您设备上的浏览信息。',
    decline: '拒绝',
    accept: '同意'
  },
  game: {
    loginbtn:'Login via Game',
    useTitle: '游戏ID',
    checkBtn: '验证',
    checktext: '您可在游戏内的设置界面查看游戏ID，或点击问号图标查看具体操作指示。',
    username: '账号名：',
    userId: '游戏ID：',
    edit: '更换',
    packageTitle: '选择礼包',
    paymentTitle: '支付方式',
    total: '合计',
    goPay: '去支付',
    noSelectPackageTips: '您还未选择礼包',
    payFail: '支付失败',
    payFailTips1: '请联系',
    payFailTips2: '客服了解情况',
    deliveryFail: '礼包发送失败',
    deliveryFailTips: '请联系游戏内客服了解详情',
    paySuccess: '支付成功',
    paySuccessTips: '稍后您会收到礼包内容',
    paySuccessTips2: '您需要重新登录游戏才能收取礼包！',
    orderTitle: '订单信息',
    paidWith: '支付方式',
    orderID: '订单编号',
    transactionId: '交易号',
    payStatus: '交易状态',
    orderTotal: '合计',
    transactionDate: '交易时间',
    camelPayfail: '支付失败',
    camelPaySuccess: '支付成功',
    camelDeliveryFail: '礼包发送失败',
    goOnPay: '继续购买',
    getInvoice: '获取凭据',
    confirmOrder: '确认订单',
    confirmFollow: '请确认下列信息：',
    nickname: '账号名称',
    packageName: '礼包名称',
    totalPayment: '合计',
    confirmPayWith: '支付方式',
    confirmAndGoOn: '确认并继续',
    orderCancel: '取消',
    getInvoiceTitle: '获取票据',
    getInvoiceTips: '请在下方输入邮箱地址，我们会将订单收据发送至您的邮箱。',
    getInvoiceTips1: '请输入邮箱地址',
    getInvoiceTips2: '同意点点互动存储我的邮箱地址。',
    getInvoiceTips3: '同意点点互动向我的邮箱，发送游戏新闻和折扣促销等资讯。',
    invoiceSend: '发送',
    sendSuccess: '发送成功',
    id404: '未找到该游戏ID!',
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh.js